export const PLAN_TYPE_MAP = {
  "403bAdmin": {
    label: "403(b) Admin",
    code: "403bAdmin",
    description:
      "A 403(b) Admin is a retirement savings plan generally offered by public schools and other tax-exempt organizations that allows employees to make contributions on a pretax or post-tax basis. Most plans allow you to start, stop, increase or decrease contributions at any time. The employer determines the investment providers and employees must open an account with one of those providers to contribute. Employers may also make contributions on behalf of employees.",
  },
  "457bAdmin": {
    label: "457(b) Admin",
    code: "457bAdmin",
    description:
      "A 457(b) Admin is a retirement savings plan generally offered by public schools and other tax-exempt organizations that allows employees to make contributions on a pretax or post-tax basis. Most plans allow you to start, stop, increase or decrease contributions at any time. The employer determines the investment providers and employees must open an account with one of those providers to contribute. Employers may also make contributions on behalf of employees.",
  },
  "457b": {
    label: "457(b)",
    code: "457b",
    description:
      "A 457(b) is a retirement savings plan that allows employees to make contributions on a pretax basis, thus income taxes are deferred until your assets are withdrawn. Most plans allow you to start, stop, increase or decrease contributions at any time. The contribution limits are separate from those of 401(k) and 403(b) plans and more flexible withdrawal options are often available.",
  },
  "401k": {
    label: "401(k)",
    code: "401k",
    description:
      "A 401(k) is a qualified retirement plan that allows eligible employees of a company to save and invest for their own retirement on a pre-tax or post-tax basis. You decide how much money you want to be deducted from your paycheck and deposited to the plan based on limits imposed by plan provisions and IRS rules. Employers may also make contributions on behalf of employees.",
  },
  "401a": {
    label: "401(a)",
    code: "401a",
    description:
      "A 401(a) is a retirement savings plan that allows accumulation of tax-advantaged funds for retirement with contributions coming from the employer, the employee or both. Employers may match a fixed percentage of employee contributions or contribute without a required employee contribution. Since this plan type is often used as an incentive, vesting schedules for funds are often associated with it",
  },
  "403b": {
    label: "403(b)",
    code: "403b",
    description:
      "A 403(b) is a retirement savings plan generally offered by public schools and other tax-exempt organizations that allows employees to make contributions on a pretax or post-tax basis. Most plans allow you to start, stop, increase or decrease contributions at any time. The employer determines the investment providers and employees must open an account with one of those providers to contribute. Employers may also make contributions on behalf of employees.",
  },
  DefinedBenefits: {
    label: "Defined Benefit",
    code: "DefinedBenefits",
    description:
      "A defined benefit plan, often referred to as a pension plan, is a retirement plan in which an employer provides a  retirement income for employees. The Employer provides a guaranteed retirement benefit to employees based on a set formula, which takes into account your salary, age and time with the organization.  The employer contributes to and manages your retirement account on your behalf. In retirement, you draw a dependable check from the company plan, regardless of how the market performs. In some plans you are allowed to receive a lump sum payment instead of a pension.",
  },
  Region10TERRP: {
    label: "Region 10 Retirement Benefits Plan",
    code: "Region10TERRP",
    description: "",
  },
  Region10Match: {
    label: "Region 10 Match Plan",
    code: "Region10Match",
    description:
      "A 401(a) Match plan is a retirement savings plan that allows accumulation of tax-advantaged funds for retirement with contributions coming from the employer. Employers may match a fixed percentage of employee contributions into their 403(b) or 457 Plans. Since this plan type is often used as an incentive, vesting schedules for funds are often associated with it ",
  },
  FinPath403b: {
    label: "FinPath 403(b)",
    code: "FinPath403b",
    description:
      "A 403(b) is a retirement savings plan generally offered by public schools and other tax-exempt organizations that allows employees to make contributions on a pretax or post-tax basis. Most plans allow you to start, stop, increase or decrease contributions at any time. The employer determines the investment providers and employees must open an account with one of those providers to contribute. Employers may also make contributions on behalf of employees.",
  },
  "403bMatch": {
    label: "403(B) Match",
    code: "403bMatch",
    description:
      "A 403(b) Admin is a retirement savings plan generally offered by public schools and other tax-exempt organizations that allows the employer, the employee or both to make contributions. In a Match Plan, employers may match a fixed percentage of employee contributions into their voluntary retirement plans. Since this plan type is often used as an incentive, vesting schedules for funds are often associated with it",
  },
  ORP: {
    label: "Optional Retirement Program (ORP)",
    code: "ORP",
    description:
      "An Optional Retirement Program (ORP) is a type of defined contribution plan. An employee and their employer both contribute to the account. Employees are responsible for picking their investments or investment provider in the plan",
  },
  FICA: {
    label: "FICA",
    code: "FICA",
    description:
      "FICA Alternative plans to provide all employees the opportunity to have retirement savings and to lessen the employer's Social Security tax burden. Participating employees are not subject to Social Security taxes while covered by this plan. Contributions to this plan are made on a pretax basis.",
  },
  FinPath457b: {
    label: "FinPath 457(b)",
    code: "FinPath457b",
    description:
      "A 457(b) is a retirement savings plan that allows employees to make contributions on a pretax basis, thus income taxes are deferred until your assets are withdrawn. Most plans allow you to start, stop, increase or decrease contributions at any time. The contribution limits are separate from those of 401(k) and 403(b) plans and more flexible withdrawal options are often available.",
  },
  "403b9Church": {
    label: "403(b)(9) Church Plan",
    code: "403b9Church",
    description:
      "A 403(b)(9) church plan is a retirement savings arrangement established under IRC Section 403(b)(9) by a church or church-controlled organization. These plans are generally exempt from ERISA requirements. Employees may make pre-tax or Roth contributions, and qualifying ministers may be eligible for a housing allowance exclusion under IRC Section 107. Employers may also make contributions on behalf of employees. Investment options are determined by the employer, and participants must open an account with an approved provider to contribute.",
  },
  NQDC: {
    label: "Non-Qualified Deferred Compensation (NQDC)",
    code: "NQDC",
    description:
      "A Non-Qualified Deferred Compensation (NQDC) plan is an arrangement between an employer and select employees that allows participants to defer a portion of their compensation to a future date, typically retirement or separation from service. Unlike qualified plans, NQDC plans are not subject to ERISA contribution limits but also do not carry ERISA protections. Deferred amounts remain a general asset of the employer and are subject to creditor claims. These plans must comply with IRC Section 409A, which governs deferral elections and permissible distribution events.",
  },
};

const DEV_HOSTNAMES = new Set(["localhost", "doclibtest.tcgservices.com", "cloud9", "doclib-client-test-forms.tcgservices.com"]);

export const IS_DEV = (
  DEV_HOSTNAMES.has(window.location.hostname) ||
  process.env.NODE_ENV === "development"
);

export const API_URL = process.env.REACT_APP_API_URL || "https://doclibapi.tcgservices.com";
